;(function () {
	const sliderInstances = new WeakMap()
	const resizeObservers = new WeakMap()
	const storyObservers = new WeakMap()
	const mobileSyncCleanups = new WeakMap()
	const lockedConnectorWrappers = new WeakSet()

	const getInnerRoot = (section) => {
		if (!section) return null
		if (section.classList && section.classList.contains('numbered-items-section') && section.dataset.phoneStory !== undefined) {
			return section
		}
		return (
			section.querySelector('.numbered-items-section[data-phone-story]') ||
			section.querySelector('.numbered-items-section')
		)
	}

	const isPhoneStorySection = (section) => {
		const inner = getInnerRoot(section)
		return !!(inner && inner.dataset.phoneStory === 'true')
	}

	const setStoryActiveStep = (section, index) => {
		const inner = getInnerRoot(section)
		if (!inner || inner.dataset.phoneStory !== 'true') return

		const cards = inner.querySelectorAll('[data-story-step]')
		const screens = inner.querySelectorAll('[data-step-screen]')
		if (!cards.length || !screens.length) return

		let activeIndex = Number(index)
		if (Number.isNaN(activeIndex)) activeIndex = 0
		activeIndex = Math.max(0, Math.min(activeIndex, cards.length - 1))

		cards.forEach((card, cardIndex) => {
			card.classList.toggle('is-active', cardIndex === activeIndex)
		})

		screens.forEach((screen, screenIndex) => {
			screen.classList.toggle('is-active', screenIndex === activeIndex)
		})
	}

	const clearMobileSync = (section) => {
		const cleanup = mobileSyncCleanups.get(section)
		if (typeof cleanup === 'function') cleanup()
		mobileSyncCleanups.delete(section)
	}

	const disconnectStoryObserver = (section) => {
		const observer = storyObservers.get(section)
		if (!observer) return
		if (typeof observer === 'function') observer()
		else if (typeof observer.disconnect === 'function') observer.disconnect()
		storyObservers.delete(section)
	}

const initStoryObserver = (section) => {
	const inner = getInnerRoot(section)
	if (!inner || inner.dataset.phoneStory !== 'true') return

	disconnectStoryObserver(section)
	if (window.innerWidth < 990) return

	const cards = Array.from(inner.querySelectorAll('[data-story-step]'))
	if (!cards.length) return

	let ticking = false
	let activeIndex = 0
	let releaseLocked = false
	let releaseLockScrollY = 0

const SWITCH_HYSTERESIS = 4
const SWITCH_OFFSET_PX = 10
const UNLOCK_OFFSET_PX = 0


	const getSwitchAnchorY = (card) => {
		const main = card.querySelector('.numbered-items-card__main')
		const anchor = main || card
		const rect = anchor.getBoundingClientRect()
		return rect.top
	}

	const getUnlockAnchorY = (card) => {
		const heading = card.querySelector('.numbered-items-card__heading')
		const kicker = card.querySelector('.numbered-items-card__step-kicker')
		const main = card.querySelector('.numbered-items-card__main')
		const anchor = heading || kicker || main || card
		return anchor.getBoundingClientRect().top
	}

	const updateFromScroll = () => {
		const viewportHeight = window.innerHeight || document.documentElement.clientHeight
		const phone = inner.querySelector('.numbered-items-phone')

		const headerCandidates = document.querySelectorAll(
			'.shopify-section-group-header-group, #shopify-section-header, .header-wrapper, header'
		)
		let headerVisible = 0
		headerCandidates.forEach((el) => {
			const styles = window.getComputedStyle(el)
			if (styles.position !== 'fixed' && styles.position !== 'sticky') return
			const rect = el.getBoundingClientRect()
			if (rect.bottom <= 0 || rect.top > 0) return
			headerVisible = Math.max(headerVisible, Math.min(rect.bottom, viewportHeight * 0.25))
		})

		const headerOffset = headerVisible * 0.5
		inner.style.setProperty('--ni-header-offset', `${headerOffset.toFixed(2)}px`)
		
const phoneRect = phone ? phone.getBoundingClientRect() : null
        /* Shifted to 70% down the screen so the text triggers significantly earlier! */
        const switchY = viewportHeight * 0.70;
        const unlockY = phoneRect ? phoneRect.top + UNLOCK_OFFSET_PX : viewportHeight * 0.14

		let candidateIndex = 0
		cards.forEach((card, idx) => {
			if (getSwitchAnchorY(card) <= switchY) candidateIndex = idx
		})

const lastIndex = cards.length - 1
const currentScroll = window.scrollY || window.pageYOffset || 0


if (candidateIndex > activeIndex) {
	if (getSwitchAnchorY(cards[candidateIndex]) <= switchY - SWITCH_HYSTERESIS) {
		activeIndex = candidateIndex
	}
} else if (candidateIndex < activeIndex) {
	if (getSwitchAnchorY(cards[activeIndex]) >= switchY + SWITCH_HYSTERESIS) {
		activeIndex = candidateIndex
	}
}

const lastCardTop = cards[lastIndex].getBoundingClientRect().top

if (!releaseLocked && activeIndex === lastIndex && lastCardTop <= unlockY) {
	releaseLocked = true
	releaseLockScrollY = currentScroll
}

if (releaseLocked && currentScroll < releaseLockScrollY - 180 && lastCardTop > unlockY + 140) {
	releaseLocked = false
}




		if (releaseLocked) activeIndex = lastIndex

		setStoryActiveStep(section, activeIndex)
		inner.classList.toggle('ni-story-complete', releaseLocked)
	}

	const requestUpdate = () => {
		if (ticking) return
		ticking = true
		window.requestAnimationFrame(() => {
			updateFromScroll()
			ticking = false
		})
	}

	inner.classList.remove('ni-story-complete')
	setStoryActiveStep(section, 0)
	requestUpdate()

	window.addEventListener('scroll', requestUpdate, { passive: true })
	window.addEventListener('resize', requestUpdate)

	storyObservers.set(section, () => {
		window.removeEventListener('scroll', requestUpdate)
		window.removeEventListener('resize', requestUpdate)
		inner.classList.remove('ni-story-complete')
	})
}


	const addClasses = (slider) => {
		const sliderWrapper = slider.querySelector('.numbered-items-list__wrapper')
		const slides = slider.querySelectorAll('.numbered-items-list__item')

		slider.classList.add('swiper')
		if (sliderWrapper) sliderWrapper.classList.add('swiper-wrapper')
		if (slides.length > 1) slides.forEach((slide) => slide.classList.add('swiper-slide'))
	}

	const removeClasses = (slider) => {
		const sliderWrapper = slider.querySelector('.numbered-items-list__wrapper')
		const slides = slider.querySelectorAll('.numbered-items-list__item')

		slider.classList.remove('swiper')
		if (sliderWrapper) sliderWrapper.classList.remove('swiper-wrapper')
		slides.forEach((slide) => {
			slide.removeAttribute('style')
			slide.classList.remove('swiper-slide')
		})
	}
	const initMobileSync = (section, swiper) => {
		const inner = getInnerRoot(section)
		if (!inner || inner.dataset.phoneStory !== 'true') return
		if (window.innerWidth >= 990) return

		clearMobileSync(section)

		const mobileTransition = inner.dataset.mobilePhoneTransition || 'swipe-sync'
		if (mobileTransition !== 'swipe-sync') {
			inner.classList.remove('numbered-items-section--mobile-sync')
			return
		}

		const screensViewport = inner.querySelector('.numbered-items-phone__screens')
		if (!screensViewport) return
		const swipeArea = inner.querySelector('.numbered-items-phone') || screensViewport

		let track = screensViewport.querySelector('.numbered-items-phone__screens-track')
		if (!track) {
			track = document.createElement('div')
			track.className = 'numbered-items-phone__screens-track'
			const screens = Array.from(screensViewport.querySelectorAll('.numbered-items-phone__screen'))
			screens.forEach((screen) => track.appendChild(screen))
			screensViewport.appendChild(track)
		}

		inner.classList.add('numbered-items-section--mobile-sync')

		const clamp = (n, min, max) => Math.max(min, Math.min(max, n))
		const getMaxIndex = () => Math.max(0, (swiper.slides || []).length - 1)
		const getViewportWidth = () => screensViewport.clientWidth || 1
		const getProgress = () => clamp(Number(swiper.progress) || 0, 0, 1)
		const progressToX = (progress) => -(clamp(progress, 0, 1) * getMaxIndex() * getViewportWidth())
		const indexToX = (index) => -(clamp(index, 0, getMaxIndex()) * getViewportWidth())

		let rafId = null
		let phoneDragActive = false
		let phoneDragMoved = false
		let phoneDragStartX = 0
		let phoneDragStartY = 0
		let phoneDragStartProgress = 0

		const setTrackTransition = (enabled, duration) => {
			if (!enabled) {
				track.style.transition = 'none'
				return
			}
			const ms = Math.max(140, Number(duration) || Math.min(240, Number(swiper.params.speed) || 220))
			track.style.transition = `transform ${ms}ms cubic-bezier(0.22, 1, 0.36, 1)`
		}

		const applyX = (x) => {
			track.style.transform = `translate3d(${x.toFixed(3)}px, 0, 0)`
		}

		const renderFromProgress = () => {
			rafId = null
			if (window.innerWidth >= 990) return
			if (getMaxIndex() === 0) {
				applyX(0)
				return
			}
			applyX(progressToX(getProgress()))
		}

		const queueRenderFromProgress = () => {
			if (rafId) return
			rafId = window.requestAnimationFrame(renderFromProgress)
		}

		const animateToActiveIndex = (duration) => {
			if (getMaxIndex() === 0) {
				applyX(0)
				return
			}
			const index = clamp(
				typeof swiper.realIndex === 'number' ? swiper.realIndex : swiper.activeIndex || 0,
				0,
				getMaxIndex()
			)
			setTrackTransition(true, duration)
			applyX(indexToX(index))
		}

		const getTouchPoint = (event) => {
			const touch = (event.touches && event.touches[0]) || (event.changedTouches && event.changedTouches[0])
			if (!touch) return null
			return { x: touch.clientX, y: touch.clientY }
		}

		const onSwiperTouchStart = () => setTrackTransition(false)
		const onSwiperFirstMove = () => {
			setTrackTransition(false)
			queueRenderFromProgress()
		}
		const onSwiperSetTranslate = () => {
			if (!phoneDragActive) queueRenderFromProgress()
		}
		const onSwiperTransitionStart = () => {
			if (phoneDragActive) return
			animateToActiveIndex(Math.min(240, Math.max(150, Number(swiper.params.speed) || 220)))
		}
		const onSwiperTransitionEnd = () => {
			setTrackTransition(false)
			queueRenderFromProgress()
		}
		const onSlideChange = () => {
			if (!phoneDragActive) {
				animateToActiveIndex(Math.min(240, Math.max(150, Number(swiper.params.speed) || 220)))
			}
		}

		const onPhoneTouchStart = (event) => {
			const point = getTouchPoint(event)
			if (!point) return
			phoneDragActive = true
			phoneDragMoved = false
			phoneDragStartX = point.x
			phoneDragStartY = point.y
			phoneDragStartProgress = getProgress()
			setTrackTransition(false)
		}

		const onPhoneTouchMove = (event) => {
			if (!phoneDragActive) return
			const point = getTouchPoint(event)
			if (!point) return

			const dx = point.x - phoneDragStartX
			const dy = point.y - phoneDragStartY

			if (Math.abs(dx) < 4) return
			if (Math.abs(dx) <= Math.abs(dy)) return

			if (event.cancelable) event.preventDefault()
			if (getMaxIndex() === 0) return

			phoneDragMoved = true
			const deltaProgress = dx / (getViewportWidth() * getMaxIndex())
			const nextProgress = clamp(phoneDragStartProgress - deltaProgress, 0, 1)
			swiper.setProgress(nextProgress, 0)
			applyX(progressToX(nextProgress))
		}

		const finishPhoneDrag = () => {
			if (!phoneDragActive) return
			phoneDragActive = false
			if (!phoneDragMoved || getMaxIndex() === 0) return

			const targetIndex = clamp(Math.round(getProgress() * getMaxIndex()), 0, getMaxIndex())
			const snapMs = 180
			setTrackTransition(true, snapMs)
			applyX(indexToX(targetIndex))
			swiper.slideTo(targetIndex, snapMs)
		}

		swiper.on('touchStart', onSwiperTouchStart)
		swiper.on('sliderFirstMove', onSwiperFirstMove)
		swiper.on('setTranslate', onSwiperSetTranslate)
		swiper.on('transitionStart', onSwiperTransitionStart)
		swiper.on('transitionEnd', onSwiperTransitionEnd)
		swiper.on('slideChange', onSlideChange)
		swiper.on('resize', queueRenderFromProgress)
		swiper.on('observerUpdate', queueRenderFromProgress)

		swipeArea.addEventListener('touchstart', onPhoneTouchStart, { passive: true })
		swipeArea.addEventListener('touchmove', onPhoneTouchMove, { passive: false })
		swipeArea.addEventListener('touchend', finishPhoneDrag)
		swipeArea.addEventListener('touchcancel', finishPhoneDrag)

		queueRenderFromProgress()

		mobileSyncCleanups.set(section, () => {
			if (rafId) cancelAnimationFrame(rafId)
			inner.classList.remove('numbered-items-section--mobile-sync')
			track.style.transform = ''
			track.style.transition = ''

			swiper.off('touchStart', onSwiperTouchStart)
			swiper.off('sliderFirstMove', onSwiperFirstMove)
			swiper.off('setTranslate', onSwiperSetTranslate)
			swiper.off('transitionStart', onSwiperTransitionStart)
			swiper.off('transitionEnd', onSwiperTransitionEnd)
			swiper.off('slideChange', onSlideChange)
			swiper.off('resize', queueRenderFromProgress)
			swiper.off('observerUpdate', queueRenderFromProgress)

			swipeArea.removeEventListener('touchstart', onPhoneTouchStart)
			swipeArea.removeEventListener('touchmove', onPhoneTouchMove)
			swipeArea.removeEventListener('touchend', finishPhoneDrag)
			swipeArea.removeEventListener('touchcancel', finishPhoneDrag)
		})
	}

	const initSlider = (section) => {
		const slider = section.querySelector('.swiper--numbered-items')
		if (!slider || typeof Swiper === 'undefined') return null

		const existing = sliderInstances.get(slider)
		if (existing) return existing

		addClasses(slider)

		const storyMode = isPhoneStorySection(section)

		const swiper = new Swiper(slider, {
			loop: false,
			speed: storyMode ? 300 : 800,
			followFinger: true,
			threshold: 6,
			breakpoints: storyMode
				? {
						320: { slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 0 },
						750: { slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 0 },
				  }
				: {
						320: { slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 16 },
						750: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 32 },
				  },
			pagination: {
				el: slider.querySelector('.numbered-items__pagination'),
				clickable: true,
				type: 'custom',
				renderCustom: function (instance, current, total) {
					let out = ''
					for (let i = 1; i <= total; i++) {
						out +=
							i === current
								? `<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${i}"></span>`
								: `<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${i}"></span>`
					}
					return out
				},
			},
		})

		sliderInstances.set(slider, swiper)

		if (storyMode) {
			const sync = () => {
				const idx = typeof swiper.realIndex === 'number' ? swiper.realIndex : swiper.activeIndex
				setStoryActiveStep(section, idx)
			}
			swiper.on('slideChange', sync)
			swiper.on('transitionEnd', sync)
			if (window.innerWidth < 990) initMobileSync(section, swiper)
			sync()
		}

		return swiper
	}

	const destroySlider = (section) => {
		clearMobileSync(section)

		const slider = section.querySelector('.swiper--numbered-items')
		if (!slider) return

		const instance = sliderInstances.get(slider)
		if (instance && typeof instance.destroy === 'function') {
			instance.destroy(true, true)
			sliderInstances.delete(slider)
		}

		removeClasses(slider)
	}

	const syncSectionMode = (section) => {
		if (!section || !section.classList.contains('numbered-items-section')) return

		if (window.innerWidth < 990) {
			const swiper = initSlider(section)
			disconnectStoryObserver(section)
			if (isPhoneStorySection(section)) {
				if (swiper) initMobileSync(section, swiper)
				setStoryActiveStep(section, 0)
			}
		} else {
			destroySlider(section)
			initStoryObserver(section)
		}
	}

	const initSection = (section) => {
		if (!section || !section.classList.contains('numbered-items-section')) return

		const currentResizeObserver = resizeObservers.get(section)
		if (currentResizeObserver) currentResizeObserver.disconnect()

		const sectionResizeObserver = new ResizeObserver((entries) => {
			entries.forEach((entry) => syncSectionMode(entry.target))
		})

		sectionResizeObserver.observe(section)
		resizeObservers.set(section, sectionResizeObserver)

		syncSectionMode(section)
	}

	const setMobileConnectorProgress = () => {
		if (window.innerWidth >= 750) return

		const sections = document.querySelectorAll('.shopify-section.numbered-items-section')
		const viewportHeight = window.innerHeight || document.documentElement.clientHeight
		const scrollTop = window.scrollY || window.pageYOffset

		sections.forEach((section) => {
			if (isPhoneStorySection(section)) return

			const list = section.querySelector('.numbered-items-list:not(.swiper)')
			const wrapper = list ? list.querySelector('.numbered-items-list__wrapper') : null
			if (!wrapper) return

			const markers = wrapper.querySelectorAll('.numbered-items-card__number')
			if (!markers.length) return

			const startMarker = markers[0]
			const endMarker = markers[Math.min(3, markers.length - 1)]

			const wrapperRect = wrapper.getBoundingClientRect()
			const startRect = startMarker.getBoundingClientRect()
			const endRect = endMarker.getBoundingClientRect()

			const lineTop = startRect.bottom - wrapperRect.top + 2
			const lineEnd = endRect.top - wrapperRect.top - 2
			const lineMaxHeight = Math.max(0, lineEnd - lineTop)

			wrapper.style.setProperty('--ni-line-top', `${lineTop.toFixed(2)}px`)
			wrapper.style.setProperty('--ni-line-max-height', `${lineMaxHeight.toFixed(2)}px`)

			if (lineMaxHeight <= 0) {
				wrapper.style.setProperty('--ni-line-current-height', '0px')
				return
			}

			if (lockedConnectorWrappers.has(wrapper)) {
				wrapper.style.setProperty('--ni-line-current-height', `${lineMaxHeight.toFixed(2)}px`)
				wrapper.style.setProperty('--ni-line-progress', '1')
				return
			}

			const lineTopPage = scrollTop + startRect.bottom + 2
			const lineEndPage = scrollTop + endRect.top - 2
			const growStart = lineTopPage - viewportHeight * 1.05
			const growEnd = lineEndPage - viewportHeight * 0.45
			const rawProgress = (scrollTop - growStart) / Math.max(1, growEnd - growStart)
			const progress = Math.max(0, Math.min(1, rawProgress))

			const currentHeight = lineMaxHeight * progress
			wrapper.style.setProperty('--ni-line-current-height', `${currentHeight.toFixed(2)}px`)
			wrapper.style.setProperty('--ni-line-progress', progress.toFixed(4))

			if (progress >= 1) lockedConnectorWrappers.add(wrapper)
		})
	}

	let ticking = false
	const requestConnectorUpdate = () => {
		if (ticking) return
		ticking = true
		window.requestAnimationFrame(() => {
			setMobileConnectorProgress()
			ticking = false
		})
	}

	const boot = () => {
		const currentSection = document.currentScript && document.currentScript.parentElement
		initSection(currentSection)
		requestConnectorUpdate()
	}

	boot()

	document.addEventListener('shopify:section:load', function (event) {
		initSection(event.target)
		requestConnectorUpdate()
	})

	document.addEventListener('shopify:section:unload', function (event) {
		const section = event.target
		destroySlider(section)
		disconnectStoryObserver(section)

		const currentResizeObserver = resizeObservers.get(section)
		if (currentResizeObserver) currentResizeObserver.disconnect()
	})

	window.addEventListener('scroll', requestConnectorUpdate, { passive: true })
	window.addEventListener('resize', requestConnectorUpdate)
})()
